import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TemplatesPreview from './components/TemplatesPreview';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '易建站 - 免费在线建站平台',
      url: 'https://yijianzhan.com',
      description: '免费在线成网站平台，提供零门槛、无需编程的在线建站服务，海量模板任意选择，几分钟即可完成网站搭建。',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://yijianzhan.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      name: '易建站',
      url: 'https://yijianzhan.com',
      description: '免费在线成网站平台，提供零门槛、无需编程的在线建站服务。',
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '建站需要懂编程吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '完全不需要！我们的平台采用可视化拖拽编辑器，所有操作都是点击和拖拽完成的。即使你没有任何编程基础，也能在几分钟内搭建出一个专业的网站。',
          },
        },
        {
          '@type': 'Question',
          name: '免费版有什么限制吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '免费版包含了建站所需的核心功能：2000+精美模板、拖拽编辑器、响应式设计、基础SEO工具等。',
          },
        },
        {
          '@type': 'Question',
          name: '网站能在手机上正常显示吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '当然可以！我们平台上的所有模板都经过了响应式设计优化，会自动适配手机、平板和电脑等不同尺寸的屏幕。',
          },
        },
        {
          '@type': 'Question',
          name: '可以绑定我自己的域名吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '付费版用户可以将自己购买的域名绑定到网站上。我们提供了详细的域名绑定教程，整个过程只需要几分钟。',
          },
        },
        {
          '@type': 'Question',
          name: '我的网站数据安全吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '非常安全。我们使用全球顶级的云服务商提供托管服务，所有网站都默认启用了SSL加密证书（HTTPS），确保数据传输过程中的安全性。',
          },
        },
        {
          '@type': 'Question',
          name: '网站对搜索引擎友好吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，我们的平台内置了完善的SEO优化工具。你可以自定义每个页面的标题、描述和关键词，自动生成站点地图，添加结构化数据标记。',
          },
        },
      ],
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <main>
        <HeroSection />
        <FeaturesSection />
        <TemplatesPreview />
        <FaqSection />
        <CtaSection />
      </main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
    </>
  );
}